import PropTypes from "prop-types";

import { annotationPropType } from "@/view/viewPropTypes";
import { focusTextCss, annotatedTextCss } from "./AnnotatedText.style";

const propTypes = {
  annotation: annotationPropType,
  isActive: PropTypes.bool,
  isFocused: PropTypes.bool,
  text: PropTypes.string,
  __cssFor: PropTypes.shape({
    root: PropTypes.object,
  }),
};

// Will be modified in a separate ticket to account for overlapping annotations.
const AnnotatedText = ({
  annotation,
  isActive,
  isFocused,
  text,
  __cssFor,
  ...props
}) => {
  const { isStartInNode, isEndInNode, pen_name: penName } = annotation;

  return (
    <span
      css={[
        annotatedTextCss({ penName, isSelected: isActive }),
        isFocused ? focusTextCss(isStartInNode, isEndInNode) : {},
        __cssFor?.root,
      ]}
      {...props}
    >
      {text}
    </span>
  );
};

AnnotatedText.propTypes = propTypes;

export default AnnotatedText;
